export type GetCommentsApiResponse = /** status 200  */ CommentResponseBody[];
export type GetCommentsApiArg = {
  resourceId: string;
  recordId: string;
};
export type CreateCommentApiResponse = unknown;
export type CreateCommentApiArg = {
  resourceId: string;
  recordId: string;
  createCommentRequestBody: CreateCommentRequestBody;
};
export type GetCommentApiResponse = /** status 200  */ CommentResponseBody;
export type GetCommentApiArg = {
  resourceId: string;
  recordId: string;
  commentId: string;
};
export type UpdateCommentApiResponse = /** status 204  */ undefined;
export type UpdateCommentApiArg = {
  resourceId: string;
  recordId: string;
  commentId: string;
  updateCommentRequestBody: UpdateCommentRequestBody;
};
export type DeleteCommentApiResponse = /** status 204  */ undefined;
export type DeleteCommentApiArg = {
  resourceId: string;
  recordId: string;
  commentId: string;
};
export type CommentResponseBody = {
  id: string;
  createdBy: string;
  createdAt: string;
  updatedBy: string | null;
  updatedAt: string | null;
  text: string;
};
export type CreateCommentRequestBody = {
  text: string;
};
export type UpdateCommentRequestBody = {
  text: string;
};
